<template>
  <div style="height: 100%">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "courseHome"
}
</script>

<style scoped>

</style>
